var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResidentRegistration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7931 67.4162C59.6947 67.4162 63.6682 63.4427 63.6682 58.5411C63.6682 53.6395 59.6947 49.666 54.7931 49.666C49.8915 49.666 45.918 53.6395 45.918 58.5411C45.918 63.4427 49.8915 67.4162 54.7931 67.4162Z",
    stroke: "#636365",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6738 96.4619C30.6738 83.1044 41.5212 72.3467 54.789 72.3467C68.0568 72.3467 78.9042 83.194 78.9042 96.4619",
    stroke: "#636365",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 44.8249L54.7896 13L95.5792 44.8249",
    stroke: "#636365",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1241 39.9829V96.4608H20.4541V39.9829",
    stroke: "#636365",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentRegistration);
export default __webpack_public_path__ + "static/media/residentRegistration.85ddc644.svg";
export { ForwardRef as ReactComponent };